module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repo-notice"
  }, [_c('h2', {
    staticClass: "repo-notice__title"
  }, [_vm._v("项目回购通知书详情")]), _vm._v(" "), _c('div', {
    staticClass: "repo-notice__content"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.tabCurrent),
      callback: function($$v) {
        _vm.tabCurrent = $$v
      },
      expression: "tabCurrent"
    }
  }, [_c('el-radio-button', {
    staticClass: "repo-notice__tab",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("项目信息")]), _vm._v(" "), _c('el-radio-button', {
    staticClass: "repo-notice__tab",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("通知书")])], 1), _vm._v(" "), _c('div', {
    staticClass: "repo-notice__tab-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabCurrent == 1),
      expression: "tabCurrent==1"
    }],
    staticClass: "repo-notice__tab-1"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "repo-notice__base-info"
  }, [_c('tr', [_c('th', [_vm._v("产品名称:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.loanItemRepo.baseProductName))]), _vm._v(" "), _c('th', [_vm._v("买家:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.loanItemRepo.buyerName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("应收账款金额:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("addThousandSign")(_vm.loanItemRepo.accountsReceivableAmount, 2)))]), _vm._v(" "), _c('th', [_vm._v("合同信息:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.loanItemRepo.contractCode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("已还本金:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("addThousandSign")(_vm.loanItemRepo.havePayPrincipal, 2)))]), _vm._v(" "), _c('th', [_vm._v("已还利息:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("addThousandSign")(_vm.loanItemRepo.havePayInterest, 2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("未还本金:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("addThousandSign")(_vm.loanItemRepo.principal, 2)))]), _vm._v(" "), _c('th', [_vm._v("未还利息:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("addThousandSign")(_vm.loanItemRepo.interest, 2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("还款到期日:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.loanItemRepo.accountsReceivableEndTimeStr))])])])]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticClass: "repo-notice__voucher_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.voucherList,
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60",
      "label": "序号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buyerName",
      "show-overflow-tooltip": "",
      "label": "买方",
      "width": "130",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customerName",
      "show-overflow-tooltip": "",
      "label": "卖方",
      "width": "130",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contractNumber",
      "show-overflow-tooltip": "",
      "label": "商务合同号",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lnvoiceNumber",
      "show-overflow-tooltip": "",
      "label": "发票号",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票/合同金额",
      "show-overflow-tooltip": "",
      "width": "90",
      "align": "center",
      "prop": "contractAmount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("addThousandSign")(scope.row.contractAmount, 2)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应收账款金额",
      "show-overflow-tooltip": "",
      "width": "90",
      "align": "center",
      "prop": "accountsReceivableAmount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("addThousandSign")(scope.row.accountsReceivableAmount, 2)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已付金额",
      "show-overflow-tooltip": "",
      "width": "90",
      "align": "center",
      "prop": "alreadyPaidAmount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("addThousandSign")(scope.row.alreadyPaidAmount, 2)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn operation",
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push(("/FrontVoucherInfo_bl/" + (scope.row.frontApplyId) + "/" + (scope.row.voucherInfoId)))
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabCurrent == 2),
      expression: "tabCurrent==2"
    }],
    staticClass: "repo-notice__delivery-pdf",
    attrs: {
      "src": _vm.deliveryPdfUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "repo-notice__bottom"
  }, [_c('el-button', {
    staticClass: "repo-notice__bottom-btn",
    staticStyle: {
      "margin-right": "40px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.confirmStatus === 0) ? _c('el-button', {
    staticClass: "repo-notice__bottom-btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.confirmOpt()
      }
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repo-notice__sub-title-wrap"
  }, [_c('span', {
    staticClass: "repo-notice__sub-title-no"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "repo-notice__sub-title"
  }, [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repo-notice__sub-title-wrap"
  }, [_c('span', {
    staticClass: "repo-notice__sub-title-no"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "repo-notice__sub-title"
  }, [_vm._v("凭证列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6342405c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/RepoNoticeDetail.vue
// module id = 1075
// module chunks = 1